/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_PauseInputs */

const cs_sreality_pause = /** @type {(inputs: Sreality_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastavit export`)
};

const en_sreality_pause = /** @type {(inputs: Sreality_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause export`)
};

/**
* | output |
* | --- |
* | "Pause export" |
*
* @param {Sreality_PauseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_pause = /** @type {((inputs?: Sreality_PauseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_PauseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_pause(inputs)
	return cs_sreality_pause(inputs)
});